import type { Component, PropType } from 'vue';
import { type ComponentSizes, componentDefaultSize } from '../../constants';

export interface ButtonProps {
    colorScheme?: 'blue' |
        'black' |
        'red' |
        'green' |
        'outline' |
        'outline-red' |
        'outline-green' |
        'ghost' |
        'ghost-red';
    size?: ComponentSizes;
    disabled?: boolean;
    loading?: boolean;
    icon?: Component;
    noShadow?: boolean;
}

export const buttonProps = {
    colorScheme: {
        type: String as PropType<ButtonProps['colorScheme']>,
        default: 'blue',
        required: false,
    },
    size: {
        type: String as PropType<ButtonProps['size']>,
        default: componentDefaultSize,
        required: false,
    },
    disabled: {
        type: Boolean as PropType<ButtonProps['disabled']>,
        default: false,
        required: false,
    },
    loading: {
        type: Boolean as PropType<ButtonProps['loading']>,
        default: false,
        required: false,
    },
    icon: {
        type: [Object, Function] as PropType<ButtonProps['icon']>,
        default: undefined,
        required: false,
    },
    noShadow: {
        type: Boolean as PropType<ButtonProps['noShadow']>,
        default: false,
        required: false,
    },
};

export const buttonEmits = {
    click: (event: MouseEvent) => event instanceof MouseEvent,
};
